<script>
import SingleSignOnWidget from '@/Components/SingleSignOnWidget.vue'
import useTenant from '@/shared/useTenant'

export default {
    components: {
        SingleSignOnWidget
    },
    props: {
        'menuCollapsed': {
            type: Boolean
        },
    },
    computed: {
        spotlerSSOEnabled() {
            return !!useTenant().value.customer.spotler_sso_enabled_at
        }
    }
}
</script>

<template>
    <div
        class="p-4"
        :class="{
            'flex items-center h-16': !menuCollapsed,
            'justify-center': !spotlerSSOEnabled
        }"
    >
        <div
            class="flex items-center"
            :class="{
                'flex-col': menuCollapsed,
                'space-x-1': !menuCollapsed
            }"
        >
            <SingleSignOnWidget
                v-if="spotlerSSOEnabled"
                :menu-collapsed="menuCollapsed"
            />
            <img
                :class="{
                    'w-auto h-8': menuCollapsed,
                    'w-36 h-auto max-h-18': !menuCollapsed,
                    'order-1': menuCollapsed
                }"
                :src="menuCollapsed ? 'https://storage.googleapis.com/crm-data-storage/media/Spotler_beeldmerk.png' : '/images/crm_RGB_white-honesty.svg'"
                alt="Spotler CRM"
            >
        </div>
    </div>
</template>
